import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import apiService from '../services/apiService';

export default function ForceChangePasswordPage() {
  const navigate         = useNavigate();
  const { clearFirstLogin } = useAuth();

  const [form, setForm]       = useState({ currentPassword: '', newPassword: '', confirm: '' });
  const [error, setError]     = useState('');
  const [loading, setLoading] = useState(false);

  const change = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.newPassword !== form.confirm) return setError('Passwords do not match.');
    setLoading(true);
    try {
      await apiService.changePassword(form.currentPassword, form.newPassword);
      clearFirstLogin();
      navigate('/', { replace: true });
    } catch (err) {
      setError(err.message || 'Failed to change password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.logo}>Aetheris</h1>
        <p style={styles.sub}>Set your password</p>
        <p style={styles.hint}>
          Welcome! For your security, please choose a permanent password before continuing.
        </p>

        {error && <div style={styles.error}>{error}</div>}

        <form onSubmit={handleSubmit} style={styles.form}>
          <input
            style={styles.input}
            name="currentPassword"
            type="password"
            placeholder="Temporary password"
            value={form.currentPassword}
            onChange={change}
            required
          />
          <input
            style={styles.input}
            name="newPassword"
            type="password"
            placeholder="New password (min 8 chars)"
            value={form.newPassword}
            onChange={change}
            required
            minLength={8}
          />
          <input
            style={styles.input}
            name="confirm"
            type="password"
            placeholder="Confirm new password"
            value={form.confirm}
            onChange={change}
            required
          />
          <button style={styles.btn} type="submit" disabled={loading}>
            {loading ? 'Saving…' : 'Set Password & Continue'}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  page:  { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)', fontFamily: 'system-ui, -apple-system, sans-serif' },
  card:  { background: 'rgba(15, 23, 42, 0.95)', border: '1px solid rgba(59, 130, 246, 0.2)', borderRadius: '16px', padding: '48px', width: '100%', maxWidth: '420px', boxShadow: '0 25px 50px rgba(0,0,0,0.5)' },
  logo:  { fontSize: '32px', fontWeight: 'bold', color: '#6C63FF', textAlign: 'center', marginBottom: '8px', textShadow: '0 0 20px rgba(108,99,255,0.5)' },
  sub:   { color: '#e2e8f0', textAlign: 'center', marginBottom: '4px', fontSize: '18px', fontWeight: '600' },
  hint:  { color: '#94a3b8', textAlign: 'center', marginBottom: '24px', fontSize: '13px' },
  form:  { display: 'flex', flexDirection: 'column', gap: '16px' },
  input: { padding: '12px 16px', background: 'rgba(30, 41, 59, 0.8)', border: '1px solid rgba(59, 130, 246, 0.2)', borderRadius: '8px', color: '#e2e8f0', fontSize: '14px', outline: 'none' },
  btn:   { padding: '14px', background: 'linear-gradient(135deg, #6C63FF, #3b82f6)', border: 'none', borderRadius: '8px', color: 'white', fontSize: '16px', fontWeight: '600', cursor: 'pointer', marginTop: '8px' },
  error: { background: 'rgba(239,68,68,0.15)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: '8px', padding: '12px', color: '#f87171', fontSize: '14px', marginBottom: '8px' },
};
